export const removeSpecificScanCode = (code: string) => {
  if (code.startsWith('11000')) {
    return code.slice(1);
  }
  return code;
};
